<template>
  <div class="session-wrapper">
    <div class="session-right text-xs-center">
      <div class="session-table-cell">
        <div class="session-content">
          <img
            :src="appLogo"
            class="img-responsive mb-3"
          />
          <h2 class="mb-4">{{$t('message.pleaseEnterYourNewPassword')}}</h2>
          <v-form>
            <v-text-field
              :error-messages="errors.collect('password')"
              data-vv-name="password"
              :label="$t('message.password')"
              ref="newPassword"
              required
              type="password"
              v-model="newPassword"
              v-validate="'required'"
            ></v-text-field>
            <v-text-field
              :error-messages="errors.collect('password_confirmation')"
              data-vv-name="password_confirmation"
              :label="$t('message.confirmPassword')"
              required
              type="password"
              v-model="confirmPassword"
              v-validate="'required|confirmed:newPassword'"
              class="mb-4"
            ></v-text-field>
            <v-btn
              @click="submit"
              block
              color="primary"
              large
            >{{$t('message.resetPassword')}}</v-btn>
          </v-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SessionSliderWidget from 'Components/Widgets/SessionSlider'
import AppConfig from 'Constants/AppConfig'
import api from '../../api/apibackend';
import { CHANGES_PASSWORD } from '../../store/modules/auth/actions.types';

export default {
  components: {
    SessionSliderWidget
	},
  data() {
    return {
      newPassword: '',
      confirmPassword: '',
			appLogo: AppConfig.appLogo2,
			code: null
    }
	},
	created () {
		this.code = this.$route.params.code
	},
  methods: {
    async submit() {
			try {
				const valid = await this.$validator.validateAll()
				if(valid) {
					this.$store.dispatch(CHANGES_PASSWORD, {
						password: this.newPassword,
						password_confirmation: this.confirmPassword,
						code: this.code
          })
          .then(res => {
            this.$router.push('/session/login')
          })
				}
			} catch(err) {
				console.log(err)
			}
    }
  }
}
</script>
